import { Button, Col, Form, Input, message, Row, Select, Spin } from "antd"
import { request } from '../../../../shared/src/apis';
import { useEffect, useState } from "react"
import { useDispatch } from "react-redux"
import { deleteCompanyBranchApi, getCompanyBranchesByCompanyIdApi, updateCompanyBranchApi } from "../../utils/apisConsts"
import helper from "../../utils/helper"
import { errorMessage } from "../../utils/commonStringsConsts"
import { OutPutResult } from '@operations/shared';
function EditCompanyBranches() {
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [loadingData, setLoadingData] = useState(false)
    const [errorMode, setErrorMode] = useState(false)
    const [companies, setCompanies] = useState([])
    const [branches, setBranches] = useState<{ id: number, name: string, nameAr: string }[]>([])
    const [selectedCompany, setSelectedCompany] = useState(null)
    const [selectedBranch, setSelectedBranch] = useState<{ id: number, name: string, nameAr: string } | null>(null)
    const [updateLoading, setUpdateLoading] = useState(false)
    const [deleteLoading, setDeleteLoading] = useState(false)

    useEffect(() => {
        getCompanies()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const getCompanies = async () => {
        try {
            setLoadingData(true)
            const companiesRes: any = await helper.getAllCompanies()
            if (companiesRes?.status === 200) {
                setCompanies(companiesRes?.data)
                setLoadingData(false)
            } else {
                setErrorMode(true)
                setLoadingData(false)
            }
        }
        catch (error: any) {
            setLoadingData(false)
            setErrorMode(true)
        }
    }
    const getCompanyBranches = async (companyId: any) => {
        try {
            setLoadingData(true)
            const res: any = await dispatch(request({ url: getCompanyBranchesByCompanyIdApi + companyId, method: "GET" }))
            if (res?.status === 200) {
                setBranches(res?.data?.data)
                setLoadingData(false)
            } else {
                setLoadingData(false)
                setErrorMode(true)
            }
        } catch (error: any) {
            setLoadingData(false)
            setErrorMode(true)
        }
    }

    const dropDownSearch = (input: string, option: { label: string; value: number; }) => {
        return option?.label?.toLowerCase()?.indexOf(input?.toLowerCase()) >= 0
    }

    const handleResetForm = () => {
        form.resetFields()
        setSelectedBranch(null)
        setSelectedCompany(null)
    }

    const handleUpdateBranch = async (values: any) => {
        setUpdateLoading(true)
        try {
            const res: any = await dispatch(request({ url: updateCompanyBranchApi + selectedBranch?.id, method: "PUT", data: { name: values?.name, nameAr: values?.nameAr } }))

            if (res?.data?.status === 200) {
                message.success(res?.data?.message)
                handleResetForm()
            } else {
                message.error(res?.data?.status === 400 ? res?.data?.message : errorMessage)
            }
        } catch (error: any) {
            message.error(error?.response?.data?.status === 400 ? error?.response?.data?.message : errorMessage)
        } finally {
            setUpdateLoading(false)
        }
    }

    const handleDeleteBranch = async () => {
        setDeleteLoading(true)
        try {
            const res: any = await dispatch(request({ url: deleteCompanyBranchApi + selectedBranch?.id, method: "DELETE" }))
            if (res?.data?.status === 200) {
                message.success(res?.data?.message)
                handleResetForm()
            } else {
                message.error(res?.data?.status === 400 ? res?.data?.message : errorMessage)
            }
        } catch (error: any) {
            message.error(error?.response?.data?.status === 400 ? error?.response?.data?.message : errorMessage)
        } finally {
            setDeleteLoading(false)
        }
    }

    return (
        <>
            {errorMode ? <OutPutResult status={'500'} title={'Oops!'} subTitle={errorMessage}
                btnTitle={'Refresh the page'} btnClick={helper.refreshPage} />
                : <Spin size="large" spinning={loadingData}>
                    <Form
                        form={form}
                        name="editCompanyBranches"
                        onFinish={handleUpdateBranch}
                        initialValues={{ selectedBranch }}
                    >
                        <Row style={{ gap: '70px' }}>
                            <Col span={11}>
                                <label>Company<span>*</span></label>
                                <Form.Item name="companyId">
                                    <Select
                                        placeholder="Select company"
                                        showSearch
                                        filterOption={((input, option: any) => dropDownSearch(input, option))}
                                        options={companies.map((company: any) => ({ label: company.name, value: company.id }))} onChange={(value) => {
                                            form.setFieldsValue({ branch: null })
                                            setSelectedBranch(null)
                                            getCompanyBranches(value)
                                            setSelectedCompany(value)
                                        }} />
                                </Form.Item>
                            </Col>
                            <Col span={11}>
                                <label>Branches<span>*</span></label>
                                <Form.Item name="branch">
                                    <Select
                                        placeholder="Select branch"
                                        disabled={!selectedCompany}
                                        options={branches?.map((branch: any) => ({ label: branch?.name, value: branch?.id }))}
                                        showSearch
                                        filterOption={((input, option: any) => dropDownSearch(input, option))}
                                        onChange={(value) => {
                                            const branch = branches?.find((branch) => branch?.id === value) || null
                                            setSelectedBranch(branch)
                                            form.setFieldsValue({ name: branch?.name, nameAr: branch?.nameAr })
                                        }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        {selectedBranch && (
                            <>
                                <Row style={{ gap: '70px' }}>
                                    <Col span={11}>
                                        <label>Branch Name<span>*</span></label>
                                        <Form.Item name="name" rules={[{ required: true, message: 'Required' }, { pattern: helper.regexValidation.englishRegex, message: 'Please enter a valid english name' }]}>
                                            <Input placeholder="Enter branch name in english" />
                                        </Form.Item>
                                    </Col>
                                    <Col span={11}>
                                        <label>Branch Arabic Name<span>*</span></label>
                                        <Form.Item name="nameAr" rules={[{ required: true, message: 'Required' }, { pattern: helper.regexValidation.arabicRegex, message: 'Please enter a valid arabic name' }]}>
                                            <Input placeholder="Enter branch name in arabic" />
                                        </Form.Item>
                                    </Col>
                                </Row>
                                <Row style={{ marginTop: '20px' }}>
                                    <Col span={24} style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                        <Form.Item>
                                            <Button
                                                danger
                                                htmlType='reset'
                                                disabled={deleteLoading || updateLoading}
                                                onClick={handleDeleteBranch}
                                                loading={deleteLoading}
                                            >
                                                Delete
                                            </Button>
                                        </Form.Item>
                                        <Form.Item>
                                            <Button
                                                style={{ backgroundColor: "#7CC58F", borderColor: "#7CC58F" }}
                                                type="primary"
                                                htmlType="submit"
                                                loading={updateLoading}
                                                disabled={updateLoading || deleteLoading}
                                            >
                                                Update
                                            </Button>
                                        </Form.Item>
                                    </Col>
                                </Row>
                            </>
                        )}
                    </Form>
                </Spin>
            }
        </>
    )
}

export default EditCompanyBranches